import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['product']
  static values = {
    purchasedId: String // this is the id of a product in this group that has already been purchased
  }

  connect() {
    // if a product has already been purchased, disable all other products in this group
    if (this.purchasedIdValue) {
      this.productTargets.forEach(product => {
        if (product.dataset.id !== this.purchasedIdValue) {
          // make sure to clear the value first to update the order total
          product.value = ''
          product.dispatchEvent(new CustomEvent('change', { detail: 'automatic' }))

          // disable the product
          product.disabled = true
        }
      })
    }

    this.productTargets.forEach(p => {
      p.addEventListener('change', (event) => {
        // if the change event didn't originate from this controller...
        if (event.detail !== 'automatic') {
          // cycle through all products in this group
          this.productTargets.forEach(product => {
            // if the product wasn't the one that triggered the event, reset
            // the ticket selection and trigger a change event
            if (product !== event.target && product.value !== '') {
              product.value = ''
              product.dispatchEvent(new CustomEvent('change', { detail: 'automatic' }))
            }
          })
        }
      })
    })
  }
}
